import { createElement } from 'react';
import '../uniqueId.js';
import { node, func } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import '../Text/styled.js';
import '../Text/index.js';
import '../Card/styled.js';
import '../Card/CardCard.js';
import '../Card/CardHeader.js';
import '../Card/CardContent.js';
import '../Card/CardTitle.js';
import '../Card/CardFooter.js';
import '../Callout/styled.js';
import '../Callout/CalloutClose.js';
import { b as calloutPropTypes, c as calloutDefaultProps } from '../chunk-54397449.js';
import '../Callout/index.js';
import 'reakit/Overlay';
import '../Overlay/OverlayContainer.js';
import '../Overlay/styled.js';
import OverlayHide from '../Overlay/OverlayHide.js';
import '../Overlay/OverlayShow.js';
import '../Overlay/OverlayToggle.js';
import { b as overlayPropTypes, c as overlayDefaultProps } from '../chunk-7b491460.js';
import '../Overlay/index.js';
import _CalloutOverlay, { Callout } from './styled.js';

var CalloutOverlay = function CalloutOverlay(_ref) {
  var a11yDescriptionId = _ref.a11yDescriptionId,
      a11yTitleId = _ref.a11yTitleId,
      border = _ref.border,
      children = _ref.children,
      className = _ref.className,
      _closeButtonProps = _ref.closeButtonProps,
      elevation = _ref.elevation,
      footer = _ref.footer,
      hide = _ref.hide,
      hasTint = _ref.hasTint,
      icon = _ref.icon,
      onClickClose = _ref.onClickClose,
      showCloseButton = _ref.showCloseButton,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yDescriptionId", "a11yTitleId", "border", "children", "className", "closeButtonProps", "elevation", "footer", "hide", "hasTint", "icon", "onClickClose", "showCloseButton", "title", "type"]);

  var closeButtonProps = _closeButtonProps;

  if (hide) {
    closeButtonProps = _objectSpread({
      use: OverlayHide,
      // @ts-ignore
      hide: hide
    }, _closeButtonProps);
  }

  return createElement(_CalloutOverlay, props, createElement(Callout, {
    a11yDescriptionId: a11yDescriptionId,
    a11yTitleId: a11yTitleId,
    border: border,
    className: className,
    closeButtonProps: closeButtonProps,
    elevation: elevation,
    footer: footer,
    hasTint: hasTint,
    icon: icon,
    onClickClose: onClickClose,
    showCloseButton: showCloseButton // @ts-ignore
    ,
    title: title,
    type: type
  }, children));
};
var calloutOverlayPropTypes = _objectSpread({
  children: node.isRequired,
  hide: func
}, overlayPropTypes, calloutPropTypes);
CalloutOverlay.propTypes = calloutOverlayPropTypes;
var calloutOverlayDefaultProps = _objectSpread({}, overlayDefaultProps, calloutDefaultProps, {
  elevation: '300',
  hide: undefined,
  placement: 'bottom-end'
});
CalloutOverlay.defaultProps = calloutOverlayDefaultProps;
var C = CalloutOverlay;

export default C;
export { C as CalloutOverlay, calloutOverlayDefaultProps, calloutOverlayPropTypes };
